export default __webpack_public_path__ + "static/media/calendar.542eb24f.svg";